import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  AFF_BALANCES_PERMISSIONS,
  AFFILIATE_BALANCES_ROUTE_NAME,
} from '@modules/aff-balances/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  AFFILIATE_BALANCE_WITHDRAWAL_ROUTE_NAME,
} from './constants';

export class AffBalancesWithdrawalModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_BALANCES_ROUTE_NAME, {
      name: AFFILIATE_BALANCE_WITHDRAWAL_ROUTE_NAME,
      path: 'withdrawal',
      component: () => import('./pages/BalancesWithdrawalPage/BalancesWithdrawalPage.vue'),
      permission: AFF_BALANCES_PERMISSIONS.WITHDRAW,
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
